import styled, { css } from 'styled-components'
import { DatePicker as DP, Select as S } from 'antd'
import { theme } from '../../styles/_variables'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  background-image: ${props => `url(${props.bg})`};
  background-size: cover;
  border: ${props => props.border};
  padding: ${props => props.padding};
`

export const MethodButton = styled.div`
  display: flex;
  justify-content: center;
  padding: 12px 0px;
  width: 120px;
  border: 1px solid ${theme.color.primaryColor};
  border-radius: 4px;
  cursor: pointer;
  ${props => props.bg && css`
    color: ${theme.color.offWhite};
    background: ${theme.color.primaryColor};
    transition: 0.5s;
  `}
`

export const EachInput = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 8px 0 0;
`

export const DatePicker = styled(DP)`
  width: 100%;
  >div {
    >input {
      height: 35px;
      width: 100%;
    }
  }
`

export const TaxSelect = styled(S)`
  width: 100% !important;
`

export default Container
